<template>
  <div class="app-container">
    <div class="top">
      <div class="left">
        <i class="el-icon-video-camera-solid"></i>
        <p>直播名称：{{ pageData.title }}</p>
      </div>
      <div class="right">
        <div>
          <el-tag v-if="query.play_status == 2">直播中</el-tag>
          <el-tag v-if="query.play_status == 1">未开始</el-tag>
          <el-tag v-if="query.play_status == 3">已结束</el-tag>
        </div>
        <div>
          <p>观看人数</p>
          <h3>{{ pageData.count_people }}人</h3>
        </div>
      </div>
    </div>
    <div class="chart-box">
      <h3 class="title">直播在线观看人数</h3>
      <div class="flex">
        <div class="left">
          <p>累计观看人次：</p>
          <h3>{{ pageData.count_people || 0 }}</h3>
          <p>当前观看人次：</p>
          <h3>{{ pageData.user_number || 0 }}</h3>
        </div>
        <div class="right">
          <div class="bar">
            统计间隔时间：

            <span v-for="item in [5, 10, 20, 30]" :class="[interval == item ? 'act' : '']" @click="getUserList(item)">
              {{ item }}分钟</span
            >
            <!-- <span>10分钟</span>
                        <span>20分钟</span>
                        <span>30分钟</span> -->
          </div>
          <div ref="chart" v-loading="chartLoading" class="chart"></div>
        </div>
      </div>
    </div>
    <div class="table">
      <h3 class="title">用户列表</h3>
      <el-table v-loading="tableLoading" :data="tableData" border style="width: 100%">
        <el-table-column prop="uuid" label="编号" fixed="left"> </el-table-column>
        <el-table-column prop="avatar" label="头像">
          <template slot-scope="scope">
            <el-image
              style="width: 100px; height: 100px"
              :src="scope.row.avatar"
              fit="contain"
              :preview-src-list="[scope.row.cover]"
            >
            </el-image> </template
        ></el-table-column>
        <el-table-column prop="real_name" label="昵称"> </el-table-column>
        <el-table-column prop="mobile" label="电话号码"> </el-table-column>
        <el-table-column prop="start_time" label="首次进入时间" width="120"></el-table-column>
        <el-table-column prop="count_time" label="累计观看时长"> </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination
          :current-page="page_index"
          :page-sizes="[10, 20, 60, 100]"
          :page-size="page_size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { mixin } from "@/mixins/pagination.js";
import { roomData, userList } from "@/api/live.js";
export default {
  mixins: [mixin],
  data() {
    return {
      searchParam: {
        keyword: "",
      },
      chartLoading: false,
      tableLoading: false,
      interval: 5,
      pageData: {},
      chartData: [],
      query: this.$route.query,
      charts: null,
      tableData: [{}],
    };
  },
  mounted() {
    this.charts = this.$echarts.init(this.$refs.chart);
    // this.charts.setOption(this.createOption(), true)
    this.getList();
    this.getUserList();
  },
  methods: {
    createOption(arr) {
      const option = {
        title: {
          text: "直播在线观看人数",
          left: "center",
          bottom: 0,
        },
        tooltip: {
          trigger: "axis",
        },
        grid: {
          left: 0,
          top: "5%",
          right: "5%",
          bottom: "10%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: arr.map((item) => {
            return item.time;
          }),
        },
        yAxis: {
          type: "value",
        },
        series: [
          {
            data: arr.map((item) => {
              return item.number;
            }),
            type: "line",
            lineStyle: {
              color: "rgba(17, 128, 232, 1)",
            },
            itemStyle: {
              color: "rgba(23, 164, 207, 1)",
            },
            areaStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "rgba(17, 128, 232, 1)", // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "rgba(17, 128, 232, 0.5)", // 100% 处的颜色
                  },
                ],
                global: false, // 缺省为 false
              },
            },
            smooth: true,
          },
        ],
      };
      return option;
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
    },
    toDetail(row) {
      console.log(row);
      this.$router.push({
        path: "/watch-live",
        query: row,
      });
    },
    toData(row) {
      this.$router.push({
        path: "/live-data",
        query: row,
      });
    },

    banItem() {
      this.$confirm("确定要删除该直播吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$message({
            type: "success",
            message: "删除成功!",
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    async getUserList(num) {
      if (num) {
        this.interval = num;
      }
      this.chartLoading = true;
      const res = await roomData(this.query.uuid, { interval: this.interval });
      this.chartLoading = false;
      if (res) {
        this.pageData = res;
        if (res.data instanceof Array) {
          this.chartData = res.data;
          this.charts.setOption(this.createOption(res.data), true);
        }
      }
    },
    async getList() {
      this.tableLoading = true;
      const res = await userList({ uuid: this.query.uuid });
      this.tableLoading = false;
      if (res.data instanceof Array) {
        this.tableData = res.data;
        this.total = res.total;
      }
    },
  },
};
</script>

<style lang="less" scoped="scoped">
.top {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #bbb;
  padding: 10px;
  .left {
    display: flex;
    align-items: center;
    font-size: 20px;
  }
  .right {
    display: flex;
    align-items: center;
    text-align: center;
    div {
      margin: 0 20px;
    }
    h3 {
      font-size: 32px;
    }
  }
}
.title {
  line-height: 40px;
  margin-top: 20px;
}
.chart-box {
  .title {
    border-bottom: 1px solid #eee;
  }
  .flex {
    display: flex;
    .left {
      width: 20%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      text-align: right;
      line-height: 2;

      h3 {
        font-size: 32px;
      }
    }
    .right {
      text-align: right;
      width: 80%;
      .bar {
        span {
          font-size: 12px;
          margin: 0 10px;
          cursor: pointer;
          border-radius: 5px;
          padding: 5px 10px;
          &:hover,
          &.act {
            background-color: skyblue;
            color: white;
          }
        }
      }
      .chart {
        height: 400px;
      }
    }
  }
}
</style>
